/**
 * Helper file to handle popups shown on category pages in the posters gallery
 */

/**
 * Checks if conditions for showing restaurants help popup are true or not
 * @param {string} method
 * @returns {boolean}
 */
function canShowRestaurantsHelpPopUp(method) {
    return (typeof PMW.marketing !== 'undefined' && (method === 'restaurant-flyers' || method === 'menu-templates') &&
        $('.js-grid-masonry').attr('data-offset') >= PMW.marketing.POPUP_FIRST_LAZY_LOAD_TEMPLATE_COUNT);
}

/**
 * Checks if banners and popups can be shown outside gallery dialog or not
 * @returns {boolean}
 */
function canShowBannersAndPopups() {
    return (!PMW.util.isInGalleryDialog());
}

/**
 * Checks if marketing banner can be shown or not
 * @param {string} method
 * @returns {boolean}
 */
function canShowMarketingBanner(method) {
    return (typeof PMW.marketing !== 'undefined' &&
        (method === 'computer-repair-flyers'));
}

/**
 * Shows marketing banner
 * @param {string} method
 */
function showMarketingBanner(method) {
    if (canShowMarketingBanner(method)) {
        // 2024-09-01 00:00:00
        PMW.marketing.showMarketingBanner(new Date(Date.UTC(2024, 9, 1, 1, 0)));
    }
}

/**
 * Shows restauratn help popup
 * @param {string} method
 */
function showRestaurantsHelpPopup(method) {
    if (canShowRestaurantsHelpPopUp(method)) {
        setTimeout(function () {
            PMW.marketing.showRestaurantsHelpPopup();
        }, PMW.marketing.POPUP_ELAPSED_TIME_RESTAURANTS_HELP);
    }
}

/**
 * Shows all banners and popups if required
 * @param {string} method
 */
export function showBannersAndPopups(method) {
    if (canShowBannersAndPopups()) {
        showMarketingBanner(method);
        showRestaurantsHelpPopup(method);
    }
}